"use client";

import { getChainIconUrl } from "@/app/api/chains/chainIcons";
import { Badge } from "@/components/ui/badge";
import { networkToChainId } from "@/components/x402/X402ImportWizardUtils";

export function formatNetworkLabel(network: string): string {
  return network
    .split("-")
    .map(part => (part.length > 0 ? part[0].toUpperCase() + part.slice(1) : part))
    .join(" ");
}

export function NetworkChip({ network }: { network: string }) {
  const chainId = networkToChainId(network);
  const iconUrl = chainId != null ? getChainIconUrl(chainId) : null;
  const label = formatNetworkLabel(network);

  return (
    <Badge variant="surface" title={label}>
      {iconUrl ? (
        <img
          src={iconUrl}
          alt=""
          aria-hidden
          className="h-3.5 w-3.5 shrink-0 rounded-full"
          onError={e => {
            (e.currentTarget as HTMLImageElement).style.display = "none";
          }}
        />
      ) : null}
      <span>{label}</span>
    </Badge>
  );
}
